import * as v from "valibot";

import { rpcContract } from "../rpc";

export const mintWebSessionBridgeRpcContract = rpcContract({
  name: "mint-web-session-bridge",
  paramsSchema: v.object({
    returnUrl: v.pipe(v.string(), v.minLength(1), v.maxLength(2048)),
  }),
  resultSchema: v.object({
    bridgeUrl: v.string(),
    expiresAt: v.string(),
  }),
});

export type MintWebSessionBridgeParams = v.InferOutput<(typeof mintWebSessionBridgeRpcContract)["paramsSchema"]>;
export type MintWebSessionBridgeResult = v.InferOutput<(typeof mintWebSessionBridgeRpcContract)["resultSchema"]>;
